import React, {PureComponent} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import id from "@irati/utils/id"
import {H2, H3} from "@irati/ui/src/Headings"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {userSurveyTracking} from "@irati-tracking/insights"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"

import CompleteSvg from "./Complete.svg"


const FinishImg = styled.img`
  width: 100px;
  height: 100px;
  ${minWidthMedia.tablet`
    width: auto;
    height: auto;
  `}
`


const FinishWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 30px;

  > * {
    margin-bottom: 25px;

    &:last-child {
      margin-top: 15px;
    }
  }

  ${minWidthMedia.tablet`
    padding-top: 60px;


    > * {
      margin-bottom: 30px;
    }
  `}
`


class Expired extends PureComponent {
  static propTypes = {
    userSurvey: PropTypes.object.isRequired
  }

  componentDidMount() {
    const {userSurvey} = this.props
    userSurveyTracking.expired({userSurvey})
  }

  render() {
    const idNamespace = id("welcome", this.props)

    return (
      <div id={idNamespace}>
        <FinishWrapper id={id("wrapper", idNamespace)}>
          <FinishImg src={CompleteSvg} alt="User survey finished" />
          <H2 id={id("title", idNamespace)}><FormattedMessage id="insights.userSurvey.expiredSurvey.heading2" /></H2>

          <H3 id={id("sub-title", idNamespace)}>
            <FormattedMessage id="insights.userSurvey.expiredSurvey.heading3" />
          </H3>
        </FinishWrapper>
      </div>
    )
  }
}


export default injectIntl(Expired)
